import { render, staticRenderFns } from "./BrandDialog.vue?vue&type=template&id=684241b6&scoped=true&"
import script from "./BrandDialog.vue?vue&type=script&lang=js&"
export * from "./BrandDialog.vue?vue&type=script&lang=js&"
import style0 from "./BrandDialog.vue?vue&type=style&index=0&id=684241b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684241b6",
  null
  
)

export default component.exports